



































































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import AgregarLoteRecibos from '@/components/borradores/AgregarLoteRecibos.vue';
import ConceptoLoteRecibos from '@/components/borradores/ConceptoLoteRecibos.vue';
import GenerarLoteRecibos from '@/components/borradores/GenerarLoteRecibos.vue';
import EliminarBorradores from '@/components/borradores/EliminarBorradores.vue';
import firstCharsToUpperCase from '../util/firstCharsToUpperCase';

export default Vue.extend({
  components: { GenerarLoteRecibos, AgregarLoteRecibos, ConceptoLoteRecibos,
    EliminarBorradores },
  data: () => ({
    singleSelect: false,
    row: {},
    selected: [],
    ids: [],
    headers: [
      { text: 'Unidad', value: 'unidad.name', sortable: false},
      { text: 'Periodo', value: 'fechaDeEmision', sortable: false  },
      { text: 'Propietario', value: 'propietario.nombre', sortable: false  },
      // { text: 'Recibo Id', value: 'id' },
      { text: 'Serie', value: 'serie', sortable: false  },
      // { text: 'Folio', value: 'folio' },
      // { text: 'Administración', value: 'administracion.shortName' },
      // { text: 'Condominio', value: 'condominio.nombre' },
      { text: 'Conceptos', value: 'items.length', sortable: false  },
      { text: 'Subtotal', value: 'subtotal', sortable: false  },
      { text: 'Total', value: 'total', sortable: false  },
    ],
    total: 0,
    Recibos: [],
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 100,
      sortBy: ['unidad.name'],
      sortDesc: [false],
    },
    dialog: false,
    Concepto: {},
    readonly: true,
    isSelectedEmpty: true,
    precision: 2,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getBorradoresList']),
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const options = this.options;
        const result = await this.$store.dispatch('getBorradoresList', {admin, condo, options});
        console.log('getBorradoresList response ', result);
        this.Recibos = result.content;
        this.total = result.totalElements;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.selected = [];
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
    verRecibo(item) {
      this.setRecibo(item);
    },
    rowSelected(event) {
      const reciboInArray = this.isReciboInArray(event, this.selected);
      const isInArray = reciboInArray.boolValue;
      const index = reciboInArray.index;
      if (isInArray) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(event);
      }
    },
    isReciboInArray(recibo, recibosArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const rec of recibosArray) {
        if (recibo.id === rec.id) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
    goToRecibos() {
      this.$router.push({ name: 'recibos' });
    },
    goToPersistentes() {
      this.$router.push({ name: 'persistentes' });
    },
    periodo(item) {
      const fecha = this.$moment(item.periodo || item.fechaDeEmision).format('MMMM YYYY');
      return firstCharsToUpperCase(fecha);
    },
  },
  watch: {
    selected() {
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.ids = [];
        this.isSelectedEmpty = true;
      } else {
        let i = 0;
        this.ids = [];
        for (i = 0; i < this.selected.length; i++) {
          this.ids.push(this.selected[i].id);
        }
        console.log('IDS: %o', this.ids);
        this.isSelectedEmpty = false;
      }
    },
  },
});
